/*!
* Copyright (c) Microsoft Corporation.
* All rights reserved. See LICENSE in the project root for license information.
* THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
* TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
*/
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
//import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';


function getProductRefinersQuery(): DataServiceQuery {
	return new DataServiceQuery();
}

export function getProductRefinersInput( productId:string ): IDataServiceRequest {
	const query = getProductRefinersQuery();
	return query.createDataServiceRequestForOperation(
		'GetProductRefiners',
		true,
		DataServiceEntities.EcoResProductConfigurationConnSelmerExtensionClass,
		'false',
		{ bypassCache: 'get', returnEntity: 'DataServiceEntities.IEcoResProductConfigurationConnSelmer' },
		{productId: productId}
	);
}

export function getProductRefinersAsync (context: IContext, productId:string):
	AsyncResult<DataServiceEntities.IEcoResProductConfigurationConnSelmer>
{
	const request = getProductRefinersInput(productId);
	return callActionOrExecute<DataServiceEntities.IEcoResProductConfigurationConnSelmer>(request, context.callerContext);
}

function getProductDimensionsQuery(): DataServiceQuery {
	return new DataServiceQuery();
}


export function getProductDimensionsInput (productId:string): IDataServiceRequest {
	const query = getProductDimensionsQuery();
	return query.createDataServiceRequestForOperation(
		'GetProductDimensions',
		true,
		DataServiceEntities.DimensionGroupsConnSelmerExtensionClass,
		'false',
		{ bypassCache: 'get', returnEntity: 'DataServiceEntities.IDimensionGroupsConnSelmer' },
		{productId: productId}
	);
}

export function getProductDimensionsAsync (context: IContext, productId:string): AsyncResult<DataServiceEntities.IDimensionGroupsConnSelmer> {
	const request = getProductDimensionsInput(productId);
	return callActionOrExecute<DataServiceEntities.IDimensionGroupsConnSelmer>(request, context.callerContext);
}
